import React from 'react'
import Navbar from '../Components/Navbar'
import img from "../Assets/service5.jpg";
import img2 from "../Assets/service7.jpg";
import img3 from "../Assets/service9.jpg";
import Footer from '../Components/Footer';
import { Helmet } from "react-helmet";

function Blog() {
    const blogs = [
   {
    img: img,
    title: "Understanding IVF: How It Helps Couples Achieve Parenthood",
    link: "/blogdetail1",
    desc: "In Vitro Fertilization (IVF) is one of the most effective fertility treatments available today. It involves fertilizing an egg with sperm outside the body and then transferring the embryo into the uterus. IVF offers hope to couples facing infertility issues such as blocked fallopian tubes, low sperm count, or unexplained infertility. With advanced reproductive technologies and expert care, IVF has helped millions of couples achieve their dream of becoming parents.",
  },
  {
    img: img2,
    title: "Common Causes of Infertility in Women and When to Seek Help",
    link: "/blogdetail2",
    desc: "Infertility in women can be caused by various factors such as hormonal imbalance, polycystic ovary syndrome (PCOS), blocked fallopian tubes, age-related decline in egg quality, or lifestyle factors. If a couple has been trying to conceive for over a year without success, it is advisable to consult a fertility specialist. Early diagnosis and personalized treatment can significantly increase the chances of pregnancy.",
  },
  {
    img: img3,
    title: "Egg Freezing: Preserving Fertility for the Future",
    link: "/blogdetail3",
    desc: "Egg freezing is an advanced fertility preservation technique that allows women to store their eggs for future pregnancy. It is especially helpful for women who wish to delay motherhood due to career goals, medical conditions, or personal reasons. The process involves stimulating the ovaries, retrieving eggs, and freezing them safely for later use. Egg freezing provides women with greater reproductive flexibility and peace of mind.",
  },
  ];

 
  return (
    <>
    <Helmet>
  <title>Fertility & IVF Blog | PCOS, Pregnancy & Women Health Tips</title>

  <meta
    name="description"
    content="Read expert blogs on IVF, fertility, PCOS, pregnancy & women’s health by Dr. Monika Gupta. Trusted IVF specialist in Delhi with 15+ years experience."
  />

  <meta
    name="keywords"
    content="IVF blog, fertility tips, PCOS treatment tips, pregnancy tips, infertility advice, women health blog India, IVF success tips, test tube baby guide"
  />

 
  <meta property="og:title" content="Fertility & IVF Blog | Dr. Monika Gupta" />
  <meta property="og:description" content="Expert IVF, PCOS & pregnancy advice from a trusted fertility specialist." />
  <meta property="og:type" content="website" />
</Helmet>
    <Navbar/>
      <div className='banner-page'>
        <h3>Blogs</h3>

        <p>Home-Blogs</p>

        </div>

 <section className="blog-page">
      <div className="blog-container">

        {/* LEFT SIDE */}
        <div className="blog-left">

        
       
            {blogs.map((blog, index) => (
              <div key={index} className="blog-card">
                <img src={blog.img} alt="blog" />
                <h3>{blog.title}</h3>
                <a href={blog.link}>Read more →</a>
              </div>
            ))}
         

        </div>

        {/* RIGHT SIDE */}
        {/* <div className="blog-right">
          <h2>Recent Articles</h2>

          {recentArticles.map((item, index) => (
            <div key={index} className="recent-item">
              <img src={item.img} alt="recent" />
              <div>
                <span className="date">{item.date}</span>
                <p>{item.title}</p>
              </div>
            </div>
          ))}
        </div> */}

      </div>
    </section>

    <Footer/>

    
    </>
  )
}

export default Blog
